export class PacModel {
    PACKAGE_OID: number;
    PACKAGE_CODE: string;
    PACKAGE_DESC: string;
    DEFAULT_COST: number;
    HAS_OPTION: string;
    OPTION_TOTAL: number;
    TYPE: string;
}